import { WORKSHOP_CHECKLIST } from '../../constants/AssetTestConfig';

/**
 * Workshop equipment 7-point inspection checklist for RecordTestModal.
 * Extracted from RecordTestModal.jsx (Brief 44). Replaces the generic Test
 * Type + Result fields for workshop_equipment assets.
 *
 * Props:
 *   checklistValues — { [itemKey]: 'pass' | 'fail' } for answered items.
 *   setChecklistValues — setter (component owns this as local state).
 *   workshopResult — derived overall result: null | 'pass' | 'fail'.
 */
export default function WorkshopChecklistFields({ checklistValues, setChecklistValues, workshopResult }) {
  return (
    <div className="form-group">
      <span className="form-label-block">Inspection Checklist</span>
      <p className="text-muted" style={{ marginBottom: 12, fontSize: '0.9em' }}>
        Complete all items. Pass/Fail per item determines overall result.
      </p>
      {WORKSHOP_CHECKLIST.map(({ key, label, hint }) => (
        <div key={key} className="workshop-checklist-row" style={{ marginBottom: 12 }}>
          <div className="form-label-block" style={{ marginBottom: 4 }}>{label}</div>
          <p className="text-muted" style={{ fontSize: '0.85em', marginBottom: 6 }}>{hint}</p>
          <div className="segmented-control segmented-control-modal">
            <label className="segmented-option-label">
              <input
                type="radio"
                name={`workshop-${key}`}
                value="pass"
                checked={checklistValues[key] === 'pass'}
                onChange={() => setChecklistValues((prev) => ({ ...prev, [key]: 'pass' }))}
                className="segmented-radio"
              />
              <span>Pass</span>
            </label>
            <label className="segmented-option-label">
              <input
                type="radio"
                name={`workshop-${key}`}
                value="fail"
                checked={checklistValues[key] === 'fail'}
                onChange={() => setChecklistValues((prev) => ({ ...prev, [key]: 'fail' }))}
                className="segmented-radio"
              />
              <span>Fail</span>
            </label>
          </div>
        </div>
      ))}
      <div className="workshop-result-badge" style={{ marginTop: 12 }}>
        {workshopResult === null ? (
          <span className="text-muted">Complete all items</span>
        ) : workshopResult === 'fail' ? (
          <span className="result-badge result-badge-fail">FAIL</span>
        ) : (
          <span className="result-badge result-badge-pass">PASS</span>
        )}
      </div>
    </div>
  );
}
